
import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { Row, Container } from 'react-bootstrap';
import Steps from '../../../../../../components/steps/steps';

import Listing from '../../../../../../models/listing';

import SecurityTypeAndForm from './components/security-type-and-form/security-type-and-form';
import CreateSecurity from './components/security-information/security-info-pages/create-security';
import SecurityInformation2 from './components/security-information/security-info-pages/security-information2';
import SecurityInformation3 from './components/security-information/security-info-pages/security-information3';
import IssueParticipant from './components/issue-participant/issue-participant';
import SecuritySummary from './components/security-summary/security-summary';
import TermsheetSubmitted from './components/termsheet-submitted/termsheet-submitted';
import { getSecurityTypes } from './../../../../../../helpr/listingFormData';

import styles from './listing-form.module.scss';

const ListingForm = ({curInstitution, activeTabIndex, setActiveTabIndex, setListingInfo, listingInfo}) => {

  const scrollTop = () =>{
    window.scrollTo({top: 0});
  }

  /*
    Proceed to next step or back 1 step
  */
  const nextStep = (back=false) => {
    if( back && activeTabIndex > 0 ){
      setActiveTabIndex( activeTabIndex - 1 );
      scrollTop();
    } else if( activeTabIndex <= keys.length ){
      setActiveTabIndex(activeTabIndex + 1);
      scrollTop();
    }
  }

  const saveListingInfo = (newData) => {
    const listingObj = { ...listingInfo, ...newData };
    setListingInfo(new Listing(listingObj));
  }

  const setIssueParticipantList= (array) => {
    console.log(array);
    const listingObj = {
      ...listingInfo,
      participantList: array
    }
    setListingInfo(new Listing(listingObj));
  }

  const getRequiredParticipants = () => {
    let obj = {};
    let defaultMandatory = [ 'RegistrarPayingAgent', 'SellingAgent', 'UnderwriterArranger' ];

    // Optional Trustee & Market Maker
    // if ( listingInfo.securityType !== 'LTNCTD' && (getSecurityTypes().some(element=>element['value'] === listingInfo.securityType)) ){ 
    //   defaultMandatory.push('MarketMaker');
    //   defaultMandatory.push('Trustee');
    // }

    // Build Style for Required Participant Badge
    defaultMandatory.map((data,_)=>{ obj[data] = 'secondary' });
    return obj;
  }

  const keys = [
    {
      id: 'securityTypeForm',
      name: 'Security Type and Form',
      component: <SecurityTypeAndForm listingInfo={listingInfo.securityTypeAndForm} saveListingInfo={saveListingInfo} nextStep={nextStep}/>
    },
    {
      id: 'securityInformation',
      name: 'Security Information',
      component: <CreateSecurity listingInfo={listingInfo} saveListingInfo={saveListingInfo} nextStep={nextStep}/>
    },
    {
      id: 'securityInformation',
      name: 'Security Information',
      component: <SecurityInformation2 listingInfo={listingInfo.securityInformation2} saveListingInfo={saveListingInfo} nextStep={nextStep}/>
    },
    {
      id: 'securityInformation',
      name: 'Security Information',
      component: <SecurityInformation3 listingInfo={listingInfo.securityInformation3} saveListingInfo={saveListingInfo} nextStep={nextStep}/>
    },
    {
      id: 'issueParticipants',
      name: 'Issue Participants',
      component: <IssueParticipant isPublished={listingInfo.isPublished} curInstitution={curInstitution} securityList={listingInfo.securityList} issueParticipantList={listingInfo.participantList} requiredParticpants={ getRequiredParticipants() } setIssueParticipantList={setIssueParticipantList} nextStep={nextStep}/>
    },
    {
      id: 'securitySummary',
      name: 'Security Summary',
      component: <SecuritySummary listingInfo={listingInfo} saveListingInfo={saveListingInfo} nextStep={nextStep}/>
    },
    {
      id: 'termSheetSubmitted',
      name: 'Security Terms Submitted',
      component: <TermsheetSubmitted/>
    }
  ]

  return (
    <Container className={styles['listing-component']}>
      <Steps activeKeyIndex={activeTabIndex} keys={keys}/>
      <Row className={styles['form']}>
        { keys[activeTabIndex].component }
      </Row>
    </Container>
  )
}

export default withRouter(ListingForm);



